import { useCallback, useEffect, useState } from 'react';
import { XMLParser } from 'fast-xml-parser';
import { det, prod, XMLDocument } from '../shared/types/nfe';
import * as React from 'react';
import { useForm } from './useForm';
import FornecedorController from '../controllers/FornecedorController';
import ImportacaoXMLController from '../controllers/ImportacaoXMLController';
import { ProdutosResponse } from '../shared/types/importacaoXML';
import { debounce } from '@mui/material';
import { SelectAutoCompleteOptions } from '../shared/types/selectAutoComplete';
import ProdutoController from '../controllers/ProdutoController';
import { toast } from 'react-toastify';
import ClienteController from '../controllers/ClienteController';
import GrupoProdutoController from '../controllers/GrupoProdutoController';
import { Item } from '../shared/components/InputSelect';

const useXmlImport = () => {
  const [fileContent, setFileContent] = useState<XMLDocument | any>({});
  const [activeTab, setActiveTab] = React.useState('1');
  const [loading, setLoading] = React.useState(false);
  const [forncedor, setForncedor] = React.useState<any>(null);
  /* [27/10/2026] O emitente que EXISTE no cadastro mas nao esta marcado como fornecedor.
     Enquanto isto estiver preenchido, a aba Emitente oferece "marcar como fornecedor" no
     lugar de "Criar" - ver o comentario em procurarEmitenteEmOutroPapel. */
  const [emitenteEmOutroPapel, setEmitenteEmOutroPapel] =
    React.useState<any>(null);
  const [transportador, setTransportador] = React.useState<any>(null);
  const [produtos, setProdutos] = React.useState<ProdutosResponse[]>([]);
  const [produtosSearch, setProdutosSearch] = React.useState<boolean>(false);
  const [modalSearchProduct, setModalSearchProduct] =
    React.useState<boolean>(false);
  const [modalSearchActiveProd, setModalSearchActiveProd] =
    React.useState<prod>();
  const [productOptions, setProductOptions] = React.useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [activeProductSelected, setActiveProductSelected] =
    React.useState<SelectAutoCompleteOptions | null>();
  const [saveXmlIsEnabled, setSaveXmlIsEnabled] =
    React.useState<boolean>(false);
  const [showGroupProduct, setShowGroupProduct] = useState<boolean>(false);
  const [paymentOptions, setPaymentOptions] = useState<Item[]>([]);
  const [productGroup, setGroupProduct] = useState<number>()

  const onSubmit = async (data: any) => {
    setLoading(true);
    setLoading(false);
    return data;
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: fileContent,
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    const file = event.target.files?.[0];
    if (file && file.type === 'text/xml') {
      setProdutosSearch(false);

      const reader = new FileReader();
      reader.onload = (e) => {
        const xmlString = e.target?.result as string;
        /* [B1 - 27/10/2026] eNotation era true, e isso DESTRUIA a chave de 44 digitos.
           Com eNotation, numero grande demais para um Number do JavaScript (o limite e
           2^53, ~9e15) vira notacao cientifica: a chave do protNFe/infProt/chNFe chegava
           ao banco como 3.3260939528914e+43 em vez dos 44 digitos. Era por isso que a
           NFENTRADA gravava a chave nula - o dado ja vinha corrompido daqui.

           Com false, o fast-xml-parser devolve o valor original como string quando ele
           nao cabe num Number. Medido na versao 4.4.1 com o XML da COLDMIX: so o chNFe
           muda de comportamento. nProt, cStat, nNF, cNF, CNPJ, CEP, NCM, cProd, qCom e
           vUnCom saem identicos, porque nenhum deles chega perto do limite.

           Nao da para usar o atributo Id do infNFe, que tambem carrega a chave: o parser
           roda com ignoreAttributes no padrao, que e true, e descarta todo atributo.
           A outra metade deste conserto esta no script sql/203. */
        const parser = new XMLParser({
          numberParseOptions: { leadingZeros: false, hex: true, eNotation: false },
        });
        const jsonResult: any = parser.parse(xmlString);

        if (!jsonResult.nfeProc.NFe.infNFe.det.length) {
          jsonResult.nfeProc.NFe.infNFe.det = [
            jsonResult.nfeProc.NFe.infNFe.det,
          ];
        }
        setFileContent(jsonResult);
      };
      reader.readAsText(file);
    } else {
      alert('Please upload a valid XML file.');
    }
    setLoading(false);
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const getFornecedor = async (cnpj: number | undefined) => {
    if (!cnpj) return;
    console.log('🔎 CNPJ:', cnpj, '| typeof:', typeof cnpj, '| toString:', cnpj?.toString());
    setLoading(true);
    setForncedor(null);
    const response = await FornecedorController.Listar({
      UsuId: 1,
      CpfCnpj: cnpj.toString(),
      Bairro: '',
      Celular: '',
      Cep: '',
      Cidade: '',
      Numero: '',
      Nome: '',
      Endereco: '',
    });
    console.log('📦 Listar →', response.StatusCode, response.Data);
    setLoading(false);
    if (response.StatusCode === 200) {
      return response.Data[0];
    }
  };

  // Como o cadastro ja e usado hoje - para a frase dizer "cliente" quando e cliente, e
  // nao "cliente" para uma transportadora.
  const papeisDoCadastro = (cadastro: any) => {
    const papeis = [
      cadastro?.cli_cliente === 'S' ? 'cliente' : null,
      cadastro?.cli_fornecedor === 'S' ? 'fornecedor' : null,
      cadastro?.cli_transportadora === 'S' ? 'transportadora' : null,
      cadastro?.cli_vendedor === 'S' ? 'vendedor' : null,
    ].filter(Boolean);

    return papeis.length ? papeis.join(' / ') : 'sem papel marcado';
  };

  /**
   * [27/10/2026] A terceira opcao da tela.
   *
   * Ate aqui havia duas saidas quando o emitente nao era encontrado: criar, ou nada. E
   * criar falhava com 500 justamente no caso mais comum - o CNPJ ja esta na tabela
   * CLIENTE, so que com cli_fornecedor = 'N'. As duas procedures estavam certas e
   * discordavam: a busca de fornecedor filtra a flag, o cadastro recusa CNPJ repetido
   * sem olhar flag nenhuma. Quem foi cadastrado como cliente e depois passou a vender
   * para a Promatec caia exatamente nesse vao.
   *
   * Esta busca pergunta outra coisa: "este CNPJ existe, seja la em que papel?". Se
   * existir, a aba Emitente oferece marcar tambem como fornecedor; so quando NAO existe
   * e que o botao "Criar" aparece.
   *
   * Se a rota ainda nao estiver no ar (script sql/206 ou deploy da API pendentes), isto
   * devolve erro e a tela volta ao comportamento antigo: oferece Criar.
   */
  const procurarEmitenteEmOutroPapel = async (
    cnpj: number | string | undefined
  ) => {
    setEmitenteEmOutroPapel(null);
    if (!cnpj) return;

    const response = await FornecedorController.LocalizarPorCnpj(
      cnpj.toString()
    );
    // 204 = o CNPJ nao existe mesmo. Ai o fluxo normal de "Criar" esta certo.
    if (response.StatusCode !== 200) return;

    const cadastro = response.Data?.[0];
    if (!cadastro?.cli_id) return;

    /* [27/10/2026] Ha CNPJ repetido na base, e nao e caso isolado: 4 pares em hmg, e
       **29 em producao** (medido em 29/10 pelo sql/214 - em 4 deles o cadastro que tem
       movimento NAO e o de menor cli_id, que e justamente o que esta busca devolve
       primeiro). A procedure devolve todos ordenados por cli_id e aqui fica o primeiro;
       em vez de escolher calado, a tela mostra quais sao os outros. Marcar o cadastro
       errado nao da erro nenhum - a nota so entra amarrada no fornecedor errado, e o
       estrago aparece depois, no contas a pagar. */
    const outros = (response.Data as any[])
      .slice(1)
      .map((c: any) => c.cli_id)
      .filter(Boolean);

    /* O caso torto: achar aqui alguem que JA e fornecedor significa que a busca de
       fornecedor errou, nao que falte marcar. Duas causas conhecidas: CNPJ gravado
       pontuado num banco sem o script 204, e D_E_L_E_T_E nulo (a PROC_FORNECEDOR_LISTAR
       compara = 'N', esta aqui usa ISNULL). Marcar nao resolveria nenhuma das duas, e
       criar daria 500 - entao a tela diz o que esta havendo em vez de oferecer botao. */
    const jaEhFornecedor = cadastro?.cli_fornecedor === 'S';

    setEmitenteEmOutroPapel({
      ...cadastro,
      papeis: papeisDoCadastro(cadastro),
      jaEhFornecedor,
      outrosCadastros: outros,
    });

    // O usuario esta na aba Dados quando a nota e lida; sem este aviso ele so
    // descobriria a pendencia ao abrir a aba Emitente por conta propria.
    toast(
      jaEhFornecedor
        ? `O emitente ja esta cadastrado como fornecedor (codigo ${cadastro.cli_id}), mas a busca nao o encontra. ` +
            'Confira o CNPJ do cadastro. Veja a aba Emitente.'
        : `O emitente ja esta cadastrado (${papeisDoCadastro(cadastro)}), mas nao como fornecedor. ` +
            'Abra a aba Emitente para marca-lo.',
      { type: jaEhFornecedor ? 'warning' : 'info', autoClose: 8000 }
    );
  };

  /**
   * [27/10/2026] Liga a flag de fornecedor no cadastro que a busca acima encontrou.
   *
   * Uma coluna, um cli_id. Nao passa pelo Atualizar: aquele grava os tres papeis de uma
   * vez e apagaria o cliente que esta ali.
   */
  const marcarEmitenteComoFornecedor = async () => {
    const cadastro = emitenteEmOutroPapel;
    if (!cadastro?.cli_id) return;

    setLoading(true);
    try {
      const response = await FornecedorController.MarcarComoFornecedor(
        cadastro.cli_id
      );
      if (response.StatusCode !== 204 && response.StatusCode !== 200) {
        toast(
          `Nao foi possivel marcar o cadastro como fornecedor (status ${response.StatusCode}).`,
          { type: 'error' }
        );
        return;
      }

      const result = await getFornecedor(
        fileContent?.nfeProc?.NFe?.infNFe?.emit?.CNPJ
      );
      if (result?.cli_id) {
        setForncedor(result);
        setEmitenteEmOutroPapel(null);
        toast(`${cadastro.cli_nome} agora tambem e fornecedor.`, {
          type: 'success',
        });
      } else {
        // Marcou, mas a re-busca (PROC_FORNECEDOR_LISTAR) nao achou. O caso conhecido e
        // CNPJ gravado com mascara num banco onde o script 204 nao foi aplicado.
        toast(
          'Marcado como fornecedor, mas a busca nao o localizou para vincular o codigo. Confira o CNPJ do cadastro.',
          { type: 'warning' }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const getTransportador = async (nome: string) => {
    if (!nome) return;
    setLoading(true);
    setTransportador(null);
    const response = await ClienteController.ListarTransportador(nome);

    setLoading(false);
    if (response.StatusCode === 200) {
      return response.Data[0];
    }
  };

  const getProdutos = async (produtos: det[]) => {
    if (produtos?.length === 0) return;

    const codigoBarras = produtos
      .filter((i) => i.prod.cEAN !== 'SEM GTIN')
      .reduce(
        (acc, item) =>
          acc + ` ${item.prod.cEAN}`,
        ''
      );

    return await ImportacaoXMLController.consultarProdutos({
      CodigoBarras: codigoBarras.trim().replace(/ /g, ','),
    });
  };

  // Avisa que a nota ja foi importada ANTES de carregar os dados nas abas.
  // Sem isso o usuario so descobria ao clicar em Salvar, no fim do preenchimento.
  // Retorna true quando a nota ja existe (importacao deve parar).
  const notaJaImportada = async (): Promise<boolean> => {
    const numeroNf = Number(fileContent?.nfeProc?.NFe?.infNFe?.ide?.nNF ?? 0);
    if (!numeroNf) return false;

    const res = await ImportacaoXMLController.verificarNfImportada(numeroNf);
    if (!res?.jaImportada) return false;

    const nota = res?.notas?.[0];
    const detalhe = nota
      ? ` (fornecedor: ${nota.fornecedor ?? 'não identificado'}${nota.nfe_ser ? `, série ${nota.nfe_ser}` : ''})`
      : '';

    toast(`Nota Fiscal ${numeroNf} já importada${detalhe}. Importação cancelada.`, {
      type: 'error',
      autoClose: 6000,
    });
    return true;
  };

  const handleImportRegister = async () => {
    setLoading(true);

    if (await notaJaImportada()) {
      // Limpa o que foi lido do arquivo para nao deixar a tela meio preenchida.
      // Precisa zerar TAMBEM fornecedor/transportador/produtos: sem isso, o estado
      // de um import anterior permanece e a validacao reabilita o botao Salvar XML,
      // que ao ser clicado quebra em handleSaveXML (nfeProc ja foi limpo).
      setFileContent({});
      setForncedor(null);
      setEmitenteEmOutroPapel(null);
      setTransportador(null);
      setProdutos([]);
      setSaveXmlIsEnabled(false);
      setLoading(false);
      return;
    }

    const searchFornecedor = getFornecedor(
      fileContent?.nfeProc?.NFe?.infNFe?.emit?.CNPJ
    );
    const searchTransportador = getTransportador(
      fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xNome
    );
    const produtos = await getProdutos(fileContent?.nfeProc?.NFe?.infNFe?.det);

    const [resultFornecedor, resultProdutos, resultTransportador] =
      await Promise.all([searchFornecedor, produtos, searchTransportador]);

    setForncedor(resultFornecedor);
    setProdutos(resultProdutos);
    setTransportador(resultTransportador);

    // [27/10/2026] Nao achou fornecedor: antes de deixar a tela oferecer "Criar",
    // descobre se o CNPJ ja existe em outro papel. So quem nao existe mesmo e criado.
    if (!resultFornecedor?.cli_id) {
      await procurarEmitenteEmOutroPapel(
        fileContent?.nfeProc?.NFe?.infNFe?.emit?.CNPJ
      );
    } else {
      setEmitenteEmOutroPapel(null);
    }

    setLoading(false);
  };

  /**
   * [27/10/2026] O payload do Atualizar, montado sobre o cadastro que JA existe.
   *
   * Ate aqui o "Atualizar" desta tela mandava so o que o XML traz, e a
   * PROC_CLIENTE_ATUALIZAR grava TODAS as colunas: um clique apagava UF, inscricao
   * estadual, e-mail, celular, complemento, data de nascimento, nacionalidade e grupo
   * de quem tinha. A UF doi mais que as outras - sem ela a PROC_NOTA_FISCAL_GRAVAR
   * calcula o destino como interestadual e o CFOP sai 6xxx no lugar de 5xxx (foi o que
   * os scripts 200/201 tiveram de reconstruir em 27 fornecedores de producao).
   *
   * Agora o cadastro atual e a base, e o XML so sobrepoe o que realmente traz. Campo
   * vazio no XML nao apaga nada.
   *
   * Os papeis (cliente/fornecedor/transportadora) NAO entram aqui: quem cuida deles e o
   * FornecedorRepository, que manda NULL no que esta tela nao e dona, e o script 207,
   * que ensinou a procedure a nao gravar papel que veio NULL.
   */
  const montarPayloadSobreCadastroAtual = async (
    cliId: number,
    doXml: any
  ): Promise<any | null> => {
    const atual = await ClienteController.ListarUnico(cliId);
    if (atual.StatusCode !== 200 || !atual.Data?.cli_id) return null;

    const c = atual.Data;
    const base = {
      CliId: c.cli_id,
      Nome: c.cli_nome,
      RazaoSocial: c.cli_razao,
      CpfCnpj: c.cli_cpf_cnpj,
      RgIe: c.cli_rg_ie,
      DataNascimento: c.cli_datanascimento,
      Nacionalidade: c.cli_nacionalidade,
      Cep: c.cli_cep,
      Endereco: c.cli_endereco,
      Numero: c.cli_numero,
      Complemento: c.cli_complemento,
      Bairro: c.cli_bairro,
      Cidade: c.cli_cidade,
      Estado: c.cli_uf,
      Telefone: c.cli_telefone,
      Celular: c.cli_celular,
      Email: c.cli_email,
      Grupo: c.cli_grupo,
      UsuId: 1,
    };

    const doXmlPreenchido = Object.fromEntries(
      Object.entries(doXml).filter(
        ([, valor]) => valor !== undefined && valor !== null && valor !== ''
      )
    );

    return { ...base, ...doXmlPreenchido, CliId: cliId };
  };

  const updateEmitente = async () => {
    if (!forncedor?.cli_id) return;
    setLoading(true);
    try {
      const payload = await montarPayloadSobreCadastroAtual(
        forncedor.cli_id,
        handleEmitente()
      );
      if (!payload) {
        // Sem o cadastro atual em maos, atualizar apagaria o que nao foi lido.
        toast(
          'Nao foi possivel ler o cadastro atual do emitente. Nada foi alterado.',
          { type: 'error' }
        );
        return;
      }

      const response = await FornecedorController.Atualizar(payload);
      toast(
        response.StatusCode === 204
          ? 'Cadastro do emitente atualizado com os dados do XML.'
          : `Nao foi possivel atualizar o emitente (status ${response.StatusCode}).`,
        { type: response.StatusCode === 204 ? 'success' : 'error' }
      );
    } finally {
      setLoading(false);
    }
  };

  const createEmitente = async () => {
    setLoading(true);
    try {
      const response = await FornecedorController.Adicionar(handleEmitente());
      if (response.StatusCode === 204) {
        const result = await getFornecedor(
          fileContent?.nfeProc?.NFe?.infNFe?.emit?.CNPJ
        );
        if (result?.cli_id) {
          setForncedor(result);
          setEmitenteEmOutroPapel(null);
        } else {
          // Gravou, mas a re-busca por CNPJ nao localizou para vincular o codigo.
          toast(
            'Fornecedor gravado, mas nao foi localizado para vincular o codigo. Confira o cadastro/CNPJ.',
            { type: 'warning' }
          );
        }
      } else {
        // Antes qualquer status != 204 era engolido em silencio (a tela "nao fazia
        // nada" - sintoma do chamado). Agora a falha aparece para o usuario e fica
        // diagnosticavel (o detalhe do proc sai no log da API quando e 500).
        toast(
          `Nao foi possivel criar o fornecedor (status ${response.StatusCode}).`,
          { type: 'error' }
        );
      }
    } finally {
      // Garante que o spinner sempre para, mesmo se a chamada lancar excecao.
      setLoading(false);
    }
  };

  // Mesma historia do updateEmitente, do outro lado da nota.
  const updateTransportador = async () => {
    if (!transportador?.cli_id) return;
    setLoading(true);
    try {
      const payload = await montarPayloadSobreCadastroAtual(
        transportador.cli_id,
        handleTransportador()
      );
      if (!payload) {
        toast(
          'Nao foi possivel ler o cadastro atual da transportadora. Nada foi alterado.',
          { type: 'error' }
        );
        return;
      }

      const response = await FornecedorController.Atualizar(payload);
      toast(
        response.StatusCode === 204
          ? 'Cadastro da transportadora atualizado com os dados do XML.'
          : `Nao foi possivel atualizar a transportadora (status ${response.StatusCode}).`,
        { type: response.StatusCode === 204 ? 'success' : 'error' }
      );
    } finally {
      setLoading(false);
    }
  };

  const createTransportador = async () => {
    const payload = handleTransportador();
    if (!payload?.Nome) {
      toast(
        'Nao foi possivel identificar o nome da transportadora no XML. Cadastre manualmente.',
        { type: 'warning' }
      );
      return;
    }
    setLoading(true);
    try {
      const response = await FornecedorController.Adicionar(payload);
      if (response.StatusCode === 204) {
        const result = await getTransportador(
          fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xNome
        );
        if (result?.cli_id) {
          setTransportador(result);
        } else {
          // Gravou mas nao localizou pra vincular o codigo (re-busca e so por nome).
          toast(
            'Transportadora gravada, mas nao foi localizada para vincular o codigo. Confira o cadastro/nome.',
            { type: 'warning' }
          );
        }
      } else {
        toast(
          `Nao foi possivel criar a transportadora (status ${response.StatusCode}).`,
          { type: 'error' }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEmitente = () => {
    return {
      CpfCnpj: fileContent?.nfeProc?.NFe?.infNFe?.emit?.CNPJ,
      Nome: fileContent?.nfeProc?.NFe?.infNFe?.emit?.xNome,
      Cidade: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xMun,
      Cep: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.CEP,
      Bairro: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xBairro,
      Endereco: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.xLgr,
      Numero: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.nro,
      UsuId: 1,
      RazaoSocial: fileContent?.nfeProc?.NFe?.infNFe?.emit?.xNome,
      // [27/10/2026] Era `Rg_Ie`, nome que o binding do C# nao reconhece - a inscricao
      // estadual do emitente nunca chegava na API.
      RgIe: fileContent?.nfeProc?.NFe?.infNFe?.emit?.IE,
      // [27/10/2026] A UF nao era enviada, e o Atualizar a apagava. Ela vem no XML.
      Estado: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.UF,
      Telefone: fileContent?.nfeProc?.NFe?.infNFe?.emit?.enderEmit?.fone,
    };
  };

  const handleTransportador = () => {
    return {
      CpfCnpj: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.CNPJ,
      Nome: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xNome,
      Cidade: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xMun,
      Endereco: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xEnder,
      Estado: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.UF,
      UsuId: 1,
      RazaoSocial: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xNome,
      RgIe: fileContent?.nfeProc?.NFe?.infNFe?.transp?.transporta?.IE,
      IsTransport: true,
    };
  };

  const handleModalSearchProduct = (value: prod) => {
    setModalSearchActiveProd(value);
    setModalSearchProduct(true);
  };

  const handleSearchProduct = async (value: string) => {
    if (!value) return;
    const products = await ProdutoController.Listar({
      Descricao: value,
      Comissao: null,
      ProdutoId_Promatec: '',
      PartNumber: '',
      CodigoBarras: '',
      Tipo: '',
    });

    if (products?.Data?.length) {
      setProductOptions(
        products.Data.map((item: any) => {
          return {
            label: item.prod_descricao,
            value: item.prod_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelected = (value: SelectAutoCompleteOptions) => {
    if (!value?.value || !modalSearchActiveProd) return;
    setActiveProductSelected(value);
  };

  const handleCloseModalSearchProduct = () => {
    setModalSearchProduct(false);
    setActiveProductSelected(null);
    setModalSearchActiveProd(undefined);
    setGroupProduct(undefined);
    setShowGroupProduct(false);
  };

  const confirmProductSelected = () => {
    if (!activeProductSelected || !modalSearchActiveProd) return;
    form.setFieldValue(
      `nfeProc.NFe.infNFe.det[${modalSearchActiveProd.id}].prod.prod_id`,
      activeProductSelected.value
    );
    form.setFieldValue(
      `nfeProc.NFe.infNFe.det[${modalSearchActiveProd.id}].prod.prod_found`,
      true
    );
    handleCloseModalSearchProduct();
  };

  const handleSelectGroup = useCallback(async () => {
    const result = await GrupoProdutoController.Listar({} as any);
    setPaymentOptions(
      result.Data.map((item: any) => ({
        value: item.grp_id,
        label: item.grp_siglaid,
      }))
    )
  }, []);

  const handleGroupSelect = (value: any) => {
    setGroupProduct(value.target.value)
  }

  const renderSelectGroup = async () => {
    setShowGroupProduct(true);
  }

  const handleCreateProduct = async () => {
    if (!modalSearchActiveProd) return;
    const barCode =
      modalSearchActiveProd?.cEAN == 'SEM GTIN'
        ? ''
        : modalSearchActiveProd?.cEAN;

    const result = await ProdutoController.Adicionar({
      Descricao: modalSearchActiveProd?.xProd,
      Disponivel: 'S',
      Variacao: '',
      CodigoBarras: barCode,
      UnidadeMedida: modalSearchActiveProd.uCom,
      ValorCusto: modalSearchActiveProd.vProd,
      Marca: '',
      Modelo: '',
      Fabricante: '',
      Observacao: '',
      NCM: modalSearchActiveProd.NCM.toString(),
      UsuId: 1,
      Grupo: productGroup?.toString()
    });

    if (result.StatusCode === 200) {
      await form.setFieldValue(
        `nfeProc.NFe.infNFe.det[${modalSearchActiveProd.id}].prod.prod_id`,
        result.Data.id
      );
      await form.setFieldValue(
        `nfeProc.NFe.infNFe.det[${modalSearchActiveProd.id}].prod.prod_found`,
        true
      );
      toast('Produto cadastrado com sucesso!', {
        type: 'success',
      });
      handleCloseModalSearchProduct();
    }
  };

  const handleSaveXML = async () => {
    const jsonData = form.values?.nfeProc;
    // Guarda: sem nota carregada (ex.: apos uma nota ja importada limpar a tela),
    // nao ha o que salvar. Antes isto estourava em jsonData.NFe e travava o spinner.
    if (!jsonData?.NFe?.infNFe) {
      toast('Nenhuma nota carregada para salvar. Importe um XML valido.', {
        type: 'error',
      });
      return;
    }
    if (!forncedor?.cli_id) {
      toast('Fornecedor nao identificado. Localize ou crie o fornecedor antes de salvar.', {
        type: 'error',
      });
      return;
    }
    setLoading(true);
    try {
      jsonData.NFe.infNFe.emit.for_id = forncedor.cli_id;
      if (transportador?.cli_id) {
        jsonData.NFe.infNFe.transp.transporta.for_id = transportador?.cli_id;
      }
      const result = await ImportacaoXMLController.salvarXml(jsonData);
      if (result.success) {
        toast('XML cadastrada com sucesso!', {
          type: 'success',
          onClose: () => window.location.reload(),
        });
        return;
      }
      toast(result.message, {
        type: 'error',
      });
    } finally {
      // Garante que o spinner sempre para, mesmo se salvarXml lancar excecao.
      setLoading(false);
    }
  };

  const validateSaveXml = () => {
    const infNFe = form?.values?.nfeProc?.NFe?.infNFe;
    // Sem nota carregada, o botao NAO pode habilitar (senao, apos limpar uma nota
    // ja importada, o fornecedor remanescente reabilitava o Salvar indevidamente).
    const hasNota = !!infNFe;
    const productWithoutId = infNFe?.det?.find(
      (item: det) => {
        return !item?.prod?.prod_id;
      }
    );
    const hasForncedor = !!forncedor?.cli_id;

    // Transportadora: o codigo so e obrigatorio quando HA transportadora informada
    // no XML E o frete NAO for "9 - sem ocorrencia de transporte".
    const modFrete = infNFe?.transp?.modFrete?.toString();
    const transporta = infNFe?.transp?.transporta;
    const temTransportadoraInfo = !!(
      transporta?.CNPJ || transporta?.CPF || transporta?.xNome
    );
    const hasTransportador =
      modFrete === '9' || !temTransportadoraInfo || !!transportador?.cli_id;

    setSaveXmlIsEnabled(hasNota && hasForncedor && !productWithoutId && hasTransportador);
  };

  useEffect(() => {
    if (fileContent?.nfeProc && !produtosSearch) {
      setProdutosSearch(true);
      handleImportRegister();
    }
  }, [fileContent]);

  useEffect(() => {
    validateSaveXml();
  }, [form?.values?.nfeProc, forncedor, transportador]);

  useEffect(() => {
    if (produtos.length) {
      const prods = fileContent?.nfeProc?.NFe?.infNFe?.det.map(
        (detItem: det) => ({
          ...detItem,
          prod: {
            ...detItem.prod,
            prod_id:
              produtos.find(
                (item) => item.prod_codigo_barras == detItem.prod.cEAN
              )?.prod_id ?? '',
            prod_found: !!produtos.find(
              (item) => item.prod_codigo_barras == detItem.prod.cEAN
            )?.prod_id,
          },
        })
      );
      setFileContent((previous: XMLDocument) => ({
        ...previous,
        nfeProc: {
          ...previous.nfeProc,
          NFe: {
            ...previous.nfeProc.NFe,
            infNFe: {
              ...previous.nfeProc.NFe.infNFe,
              det: prods,
            },
          },
        },
      }));
    }
  }, [produtos]);

  useEffect(() => {
    handleSelectGroup();
  }, [])

  const debouncedSearchProduct = debounce(handleSearchProduct, 400);

  return {
    handleFileChange,
    fileContent,
    activeTab,
    handleTabChange,
    loading,
    ...form,
    forncedor,
    emitenteEmOutroPapel,
    marcarEmitenteComoFornecedor,
    updateEmitente,
    createEmitente,
    createTransportador,
    updateTransportador,
    transportador,
    produtos,
    handleCloseModalSearchProduct,
    modalSearchProduct,
    handleModalSearchProduct,
    modalSearchActiveProd,
    handleSearchProduct: debouncedSearchProduct,
    productOptions,
    handleAutoCompleteSelected,
    confirmProductSelected,
    activeProductSelected,
    handleCreateProduct,
    handleSaveXML,
    saveXmlIsEnabled,
    renderSelectGroup,
    showGroupProduct,
    paymentOptions,
    handleGroupSelect,
    productGroup,
  };
};

export default useXmlImport;
